export default {
  danger: {
    title: 'Danger Zone',
    subtitle: 'Actions on the organization itself',
    deleteTitle: 'Delete this organization',
    deleteDescription:
      "{name} and everything in it will be deleted: its workspaces and their content, its roles, its pending invitations and its API keys. Its channels go offline and their subscribers' accounts are deleted. Any remaining credit is lost, with no refund, and its automatic top-up stops. Every member loses access. Your own account is kept.",
    confirmLabel: 'Type {name} to confirm',
    submit: 'Delete the organization',
    deleted: '{name} has been deleted.',
    alreadyDeleted: 'This organization has already been deleted.',
    failed: 'The organization could not be deleted. Try again.',
    transferTitle: 'Transfer ownership',
    transferDescription:
      'Hand {name} to another member: they take your role, and you step down to the role you choose.',
    transferMemberLabel: 'Member taking over',
    transferStepDownLabel: 'Your role afterwards',
    transferSubmit: 'Transfer the organization',
    transferConfirmTitle: 'Hand {name} over?',
    transferConfirmText: '{member} takes your role, and you become {role}. The change applies at once.',
    transferConfirm: 'Transfer',
    transferred: '{name} has been handed over to {member}.',
    transferGone: 'This member is no longer in the organization.',
    transferFailed: 'The organization could not be handed over. Try again.',
    transferNoCandidate: 'There is no other member to hand the organization to.',
  },
}
